(function () {
    'use strict';

    var registerService = function ($http, $q) {

        // add registration
        this.addRegistration = function (registration) {
            return $http.post('api/registration/create', { accountRegistration: registration } ).then(function (response) {
                    var company = response.data;
                    return company;
                },
                function (error) {
                    throw ('Error Adding Registration');
                });
        }

        this.getRegistrations = function (name, page, take) {
            return $http.post('api/registration/list',
                {
                    name: name,
                    page: page,
                    take: take
                })
                .then(function (response) {
                    var items = response.data;

                    return items;
                },
                function () {
                    throw ('Registrations Retrieval Failure');
                });
        };

        this.getRegistration = function (id) {
            return $http.get('api/registration/' + id)
                .then(function (response) {
                    var items = response.data;

                    return items;
                },
                function () {
                    throw ('Registration Retrieval Failure');
                });
        };

        this.activateRegistration = function (productAccount) {
            return $http.post('api/registration/activate', productAccount)
                .then(function (response) {
                    var items = response.data;

                    return items;
                },
                function (response) {
                    //throw ('Registration Retrieval Failure');
                    return $q.reject(response.data);
                });
        };

        this.dynamicsLookup = function (name) {
            return $http.get('api/registration/checkdynamics/' + name)
                .then(function (response) {
                    var items = response.data;

                    return items;
                },
                function (response) {
                    //throw ('Registration Retrieval Failure');
                    return $q.reject(response.data);
                });
        };
    }

    angular.module('app')
        .service('registerService', ['$http', '$q', registerService]);
})();